import BasicsCollection from '../components/CollectionBasics';

export default function Basics() {

    return(
        <BasicsCollection />
    )
}